export const COMPONENT = 'component'
export const POWER = 'power'
